import classnames from 'classnames';
import React, { FunctionComponent } from 'react';

type PenProps = {
    className?: string;
};

const Pen: FunctionComponent<PenProps> = props => {
    return (
        <svg
            className={classnames('dibsIcon', props.className)}
            data-tn={'pen'}
            viewBox="-30 0 518 518"
        >
            <polygon points="45.5,354.7 0,518 165.4,455.2 408,156.5 285.3,61.6" />
            <path d="M443.8 55.3c-9.4-8.9-54.8-44.4-61.3-48.2-31-17.8-49.6 3.1-49.6 3.1l-23.8 27.2 117.8 91.1 25.2-30c0 .1 13.1-22.9-8.3-43.2z" />
        </svg>
    );
};
export default Pen;
